import {Button} from '@luminopia/react-toolbox/lib/button'
import Confirm from 'core/components/confirm'
import * as React from 'react'
import * as classNames from './subject-controls.css'

export interface IProps {
  className?: string

  deactivateButton: boolean
  isConfirmActive: boolean
  onConfirmActivate: () => void
  onConfirmDeactivate: () => void
  onDeactivate: () => void
}

export class SubjectControls extends React.PureComponent<IProps, {}> {
  public static defaultProps = {
    deactivateButton: false,
    isConfirmActive: false,
    onConfirmActivate: () => undefined,
    onConfirmDeactivate: () => undefined,
    onDeactivate: () => undefined,
  }

  public render() {
    // TODO I18N
    return (
      <div className={this.props.className}>
        <div className={classNames.buttonsContainer}>
          {this.props.deactivateButton && <Button
            className={classNames.button}
            raised primary
            label='deactivate treatment'
            onClick={this.props.onConfirmActivate}
          />}
        </div>
        <Confirm
          title='Deactivate treatment?'
          active={this.props.isConfirmActive}
          onConfirm={this.props.onDeactivate}
          onCancel={this.props.onConfirmDeactivate}
        >
          Are you sure you want to conclude treatment for this subject?
        </Confirm>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/components/subjects/subject-controls.tsx